"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _helper = require("./helper");

var _storage = _interopRequireDefault(require("./storage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JUMBO_MEMORY_TO_JUMBO_DURATION = 2000;
var PAGEVIEW_KEY = "pageview";
var instance = null;

var Jumbo = function Jumbo() {
  _classCallCheck(this, Jumbo);

  this.setParams = function (params) {
    instance.user_id = params.user_id || 0;
    instance.city_id = params.city_id || 0;
    instance.session_id = params.session_id || "";
    instance.device_id = params.device_id || "";
    instance.url = params.url || _helper.JUMBO_URL;
  };

  this.setupCrons = function () {
    /**
         We are keeping data in memory for 2 seconds, setInterval of 2s gives enough
         time for aggregation of events in memory so that we can send those events to jumbo.zomato.com
         later in bulk
        */
    instance.jumbo_memory_flush_interval = setInterval(instance.sendEventsToJumbo, JUMBO_MEMORY_TO_JUMBO_DURATION);
  };

  this.getCityId = function () {
    return instance.city_id;
  };

  this.getSessionId = function () {
    return instance.session_id;
  };

  this.getDeviceId = function () {
    return instance.device_id;
  };

  this.getPacketHeader = function () {
    var timestamp = Math.round(new Date().getTime() / 1000);
    var headerPayload = {
      location: instance.getCityId(),
      timestamp: timestamp
    };

    if (instance.getSessionId()) {
      headerPayload.session_id = instance.getSessionId();
    }

    if (instance.getDeviceId()) {
      headerPayload.device_id = instance.getDeviceId();
    }

    return headerPayload;
  };

  this.preparePacket = function (key, values) {
    values = (0, _helper.convertToArray)(values);
    var url = document.URL;
    var formatted_events = values.map(function (value) {
      return {
        header: instance.getPacketHeader(),
        payload: {
          key: key,
          value: value,
          url: url
        }
      };
    });
    return formatted_events;
  };

  this.sendToJumbo = function (key, values) {
    var formatted_events = instance.preparePacket(key, values);
    formatted_events.map(function (event) {
      window.jumbo.push(event);
    });
  };

  this.sendPageView = function (url) {
    instance.sendToJumbo(PAGEVIEW_KEY, url);
  };

  this.addEventListeners = function () {
    var events = ["blur", "beforeunload", "unload", "online"];
    events = events.filter(function (event) {
      return window.hasOwnProperty("on" + event);
    });
    (0, _helper.addMultipleListners)(window, events, instance.sendEventsToJumbo);
  };

  this.getEventsData = function () {
    var events = instance.storage.getEventsArr();
    var events_data = {
      raw_events: null,
      processed_events: null
    };

    if ((0, _helper.isArray)(events) && events.length) {
      events_data["raw_events"] = events;
      events_data["processed_events"] = (0, _helper.formatJumboEvents)(events);
      instance.storage.clear();
    }

    return events_data;
  };

  this.lockRequest = function () {
    instance.request_in_progress = true;
  };

  this.unlockRequest = function () {
    instance.request_in_progress = false;
  };

  this.shouldSendRequest = function () {
    return !!(navigator.onLine && !instance.request_in_progress && typeof instance.user_id !== "undefined");
  };

  this.sendEventsToJumbo = function () {
    var _instance$getEventsDa = instance.getEventsData(),
        _instance$getEventsDa2 = _instance$getEventsDa.raw_events,
        raw_events = _instance$getEventsDa2 === void 0 ? [] : _instance$getEventsDa2,
        _instance$getEventsDa3 = _instance$getEventsDa.processed_events,
        processed_events = _instance$getEventsDa3 === void 0 ? [] : _instance$getEventsDa3;

    try {
      if ((0, _helper.isArray)(raw_events) && raw_events.length && instance.shouldSendRequest() && processed_events) {
        instance.lockRequest();

        if ((0, _helper.isBeaconSupported)()) {
          (0, _helper.sendViaBeaconV2)(processed_events, instance.user_id, instance.url);
          instance.unlockRequest();
        } else {
          (0, _helper.sendViaFetchV2)(processed_events, instance.user_id, instance.url).then(function (response) {
            instance.unlockRequest();
          })["catch"](function (err) {
            instance.unlockRequest();
            instance.storage.addEventsArr(raw_events);
          });
        }
      }
    } catch (e) {
      instance.unlockRequest();
      instance.storage.addEventsArr(raw_events);
      (0, _helper.ravenLog)("Jumbo Error - sendEventsToJumbo");
    }
  };
};

Jumbo.getInstance = function () {
  if (!instance) {
    window.jumbo = [];
    var obj = new Jumbo();
    instance = obj;
    instance.request_in_progress = false;
    instance.storage = new _storage["default"]();
    instance.setupCrons();
    instance.addEventListeners();
  }

  return instance;
};

var _default = Jumbo;
exports["default"] = _default;